import React, { useState } from 'react'

// queries
import { useMutation } from '@apollo/client'
import { GET_TOKEN_MUTATION } from '../../../graphql/authentication/authentication.mutation'

// collections
import LoginForm from './Login.form'

// components

// utils
import { validate } from '../../../shared/utility'

const validationSchema = {
    username: {
        type: 'input',
        validation: {
            required: true
        }
        
    },
    password: {
        type: 'input',
        validation: {
            required: true
        }
    }
}

export default function LoginFormController({ onSuccess }) {

    const [loginUser, ] = useMutation(GET_TOKEN_MUTATION)
    const [errors, setErrors] = useState({})

    const handleSubmit = (formData) => {

        // validate form
        let { isValid, errors } = validate(formData, validationSchema)

        if(isValid) {
             loginUser({ variables: {...formData}})
            .catch(e => {
            }).then(result => {

                if(result.data && result.data.tokenAuth) {

                    if(result.data.tokenAuth.success) {
                        const { token, refreshToken } = result.data.tokenAuth;
                        
                        

                        
                        onSuccess(token, refreshToken)
                    }
                }
            })
        } else {
            setErrors(errors)
        }

       
    }

    return (<div>
        <LoginForm 
            handleSubmit={handleSubmit}
            errors={errors}
        />
        </div>)
}